export default {
  SET_INTERACTIONS(state, interactions) {
    state.interactions = interactions;
  },
};
